import { createRouter, createWebHistory, RouterView } from 'vue-router';
import store from "@/store";
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { parseJwt } from '@/assets/js/utils.js';

// ----------------------------------------   User Profile   ----------------------------------------------
import UserPage from '@/views/UserPage.vue';
import Bills from '@/components/UserProfileComponent/Bills.vue';
import Transactions from '@/components/UserProfileComponent/Transactions.vue';
import AdminPage from '@/views/AdminPage.vue';
import SuperAdminPage from '@/views/SuperAdminPage.vue';
import UsageSummary from '@/components/UserProfileComponent/OrganizationSettings/OrganizationUsageSummary.vue';;

// ------------------------------   User Profile  / User  -------------------------------------
import AccountSettings from '@/components/UserProfileComponent/AccountSettings/AccountSettings.vue';
import EditUser from '@/components/UserProfileComponent/AccountSettings/EditUser.vue';

// ------------------------------   User Profile  / Admin  -------------------------------------
import OrganizationSettingsLanding from '@/components/UserProfileComponent/OrganizationSettings/Landing.vue';
import EditOrganization from '@/components/UserProfileComponent/OrganizationSettings/EditOrganization.vue';
import OrganizationSecuritySettings from '@/components/UserProfileComponent/OrganizationSettings/OrganizationSecuritySettings.vue';
import UserManagement from '@/components/UserProfileComponent/OrganizationSettings/UserManagement.vue';
import OrganizationSettings from '@/components/UserProfileComponent/OrganizationSettings/OrganizationSettings.vue';
import CreateSecondaryUser from '@/components/UserProfileComponent/CreateSecondaryUser.vue';
import ClaimCoupon from '@/components/UserProfileComponent/ClaimCoupon.vue';

// ------------------------------   User Profile  / Super Admin  -------------------------------------
import OrganizationManagement from '@/components/UserProfileComponent/OrganizationSettings/OrganizationManagement.vue';
import AddNewOrganization from '@/components/UserProfileComponent/OrganizationSettings/AddNewOrganization.vue';
import UserAddCredits from '@/components/UserProfileComponent/UserAddCredits.vue';
import EmulateUser from '@/components/UserProfileComponent/EmulateUser.vue';
import ShowDetailedOrganization from '@/components/UserProfileComponent/OrganizationSettings/ShowDetailedOrganization.vue';
import CreateCoupons from '@/components/UserProfileComponent/CreateCoupons.vue';

// ----------------------------------------   Projects   ----------------------------------------------
import Projects from '@/views/Projects.vue';
import ProjectManagement from '@/components/ProjectsComponent/ProjectManagement.vue';
import ProjectHome from '@/views/ProjectHome.vue';

// ----------------------------------------   Trainer   ----------------------------------------------
import Trainer from '@/views/Trainer.vue';
import TrainerManagement from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainerManagement.vue';
import TrainerSessionLandingPage from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainerSessionLandingPage.vue';
import TrainerSessionManagement from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainerSessionManagement.vue';
import TrainerSessionDetailsPage from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainerSessionDetailsPage.vue';
import TrainingChartsPage from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainingChartsPage.vue';
import ValidatorSessionDetailsPage from '@/components/TrainerComponent/TrainerExperimentAndSessions/ValidatorSessionDetailsPage.vue';
import CompareValidateSessionsPage from '@/components/TrainerComponent/TrainerExperimentAndSessions/CompareValidateSessionsPage.vue';
import ValidatorSessionLandingPage from '@/components/TrainerComponent/TrainerExperimentAndSessions/ValidatorSessionLandingPage.vue';

// ----------------------------------------   Dataset   ----------------------------------------------
import Datasets from '@/views/Datasets.vue';
import AnnotationEditor from '@/components/DatasetComponent/AnnotationTool/AnnotationEditor.vue';
import DatasetManagement from '@/components/DatasetComponent/DatasetManagement/DatasetManagement.vue';
import Gallery from '@/components/DatasetComponent/GalleryComponent/Gallery.vue';
import DatasetStats from '@/components/DatasetComponent/DatasetStats/DatasetStats.vue';
import Map from '@/components/DatasetComponent/Map.vue';

// ----------------------------------------   Validation   ----------------------------------------------
import Validator from '@/views/Validator.vue';
import ValidatorManagement from '@/components/ValidationPage/ValidatorManagement.vue';

// ----------------------------------------   Automation   ----------------------------------------------
import Automation from '@/views/Automation.vue';

// ----------------------------------------   Task Board   ----------------------------------------------
import TaskBoard from '@/views/TaskBoard.vue';
import GalleryLandingPage from '@/components/DatasetComponent/GalleryComponent/GalleryLandingPage.vue';

// ----------------------------------------   Annotator   ----------------------------------------------
import Annotator from '@/views/Annotator.vue';

// ----------------------------------------   Recycle Bin   ----------------------------------------------
import RecycleBin from '@/views/RecycleBin.vue';

// ----------------------------------------   Cloud Instances   ----------------------------------------------
import CloudInstancesPage from '@/views/CloudInstancesPage.vue';

// ----------------------------------------   Snapshots   ----------------------------------------------
import Snapshots from '@/views/Snapshots.vue';

// ----------------------------------------   Apps   ----------------------------------------------
import Apps from '@/views/Apps.vue';
// ----------------------------------------   Subscription   ----------------------------------------------
import Subscription from '@/views/Subscription.vue';
import TopupFunds from '@/components/UserProfileComponent/TopupFunds.vue';
import SubscriptionSuccess from '@/views/Subscription_Success.vue';
import SubscriptionFail from '@/views/Subscription_Fail.vue';

// ----------------------------------------   Home   ----------------------------------------------
import Welcome from '@/views/Welcome.vue';
import WelcomeLanding from '@/views/WelcomeLanding2.vue';
import Pricing from '@/views/Price.vue';
import Login from '@/views/Login.vue';
import Contact from '@/views/ContactUs.vue';
import Signup from '@/views/Signup.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import ReleaseNotes from '@/views/ReleaseNotes.vue';
import ValidatorSessionCharts from '@/components/ValidationPage/ValidateSessionCharts.vue';

// ----------------------------------------   Terms   ----------------------------------------------
import Terms from '@/views/Terms.vue';

import PublicProjects from '@/views/PublicProjects.vue';
import PublicDatasets from '@/views/PublicDatasets.vue';
import PublicLanding from '@/views/PublicLanding.vue';
import { useToast } from 'vue-toast-notification';
import Dashboard from '../views/Dashboard.vue';

const $toast = useToast();

const routes = [
  // {
  //   path: '/',
  //   component: WelcomeLanding,
  //   redirect: '/home',
  //   children: [
  //     {
  //       path: 'home',
  //       name: 'home',
  //       component: Welcome,
  //     },
  //     {
  //       path: 'pricing',
  //       name: 'pricing',
  //       component: Pricing,
  //     },
  //   ],
  // },
  {
    path: '/',
    name: 'landing',
    component: WelcomeLanding,
    // redirect: '/home',
    // children: [
    //   {
    //     path: 'home',
    //     name: 'home',
    //     component: Welcome,
    //   },
    //   {
    //     path: 'pricing',
    //     name: 'pricing',
    //     component: Pricing,
    //   },
    // ],
  },
  {
    path: '/releases',
    name: 'release_notes',
    component: ReleaseNotes,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
    {
    path: '/contact',
    name: 'Contact us',
    component: Contact,
  },
  {
    path: '/project',
    name: 'project',
    component: ProjectHome,
  },
    {
    path: '/price',
    name: 'pricing',
    component: Pricing,
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms,
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
  },
  {
    path: '/reset',
    name: 'reset',
    component: ResetPassword,
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/user',
    name: 'user',
    component: UserPage,
    redirect: {
      name: 'user.profile',
    },
    meta: {
      breadCrumb: 'User',
    },
    children: [
      {
        path: 'profile',
        name: 'user.profile',
        component: AccountSettings,
        meta: {
          breadCrumb: 'Profile',
          icon: 'account_circle',
        },
      },
      {
        path: 'edit',
        name: 'user.edit',
        props: true,
        component: EditUser,
        meta: {
          breadCrumb: 'Edit Info',
          icon: 'edit',
        },
      },
    ],
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPage,
    meta: {
      breadCrumb: 'Admin',
    },
    redirect: {
      name: 'admin.organization.details',
    },
    // if the breadcrumb needs to navigate between siblings, add name && icon to each child
    children: [
      {
        path: 'organization',
        name: 'admin.organization',
        component: OrganizationSettingsLanding,
        meta: {
          breadCrumb: 'Organization',
          icon: 'info',
        },
        redirect: {
          name: 'admin.organization.details',
        },
        children: [
          {
            path: 'details',
            name: 'admin.organization.details',
            component: OrganizationSettings,
            meta: {
              breadCrumb: 'Information',
              icon: 'info',
            },
          },
          {
            path: 'editorg',
            name: 'admin.organization.editorg',
            permissions: ['admin', 'super'],
            component: EditOrganization,
            meta: {
              breadCrumb: 'Edit Info',
              icon: 'edit',
            },
          },
          {
            path: 'security',
            name: 'admin.organization.security',
            permissions: ['admin', 'super'],
            component: OrganizationSecuritySettings,
            meta: {
              breadCrumb: 'Security',
              icon: 'security',
            },
          },
        ],
      },
      {
        path: 'people',
        name: 'admin.people',
        component: OrganizationSettingsLanding,
        meta: {
          breadCrumb: 'Users',
          icon: 'people',
        },
        redirect: {
          name: 'admin.people.list',
        },
        children: [
          {
            path: 'list',
            name: 'admin.people.list',
            component: UserManagement,
            meta: {
              breadCrumb: 'Manager',
              icon: 'people',
            },
          },
          {
            path: 'newuser',
            name: 'admin.people.newuser',
            component: CreateSecondaryUser,
            meta: {
              breadCrumb: 'New User',
              icon: 'person_add',
            },
          },
          {
            path: 'edituser',
            name: 'admin.people.edituser',
            component: EditUser,
            meta: {
              breadCrumb: 'Edit User',
              icon: 'edit',
            },
          },
        ],
      },
      {
        path: 'bills',
        name: 'admin.bills',
        component: Bills,
        meta: {
          breadCrumb: 'Billing',
          icon: 'usage',
        },
      },
      {
        path: 'transactions',
        name: 'admin.transactions',
        component: Transactions,
        meta: {
          breadCrumb: 'Transactions',
          icon: 'usage',
        },
      },
      {
        path: 'coupons',
        name: 'admin.coupons',
        component: ClaimCoupon,
        meta: {
          breadCrumb: 'Claim Coupon',
          icon: 'coupon',
        },
      },
      {
        path: 'subscription',
        name: 'admin.subscription',
        component: Subscription,
        meta: {
          breadCrumb: 'Subscription',
        },
      },
      {
        path: 'topup',
        name: 'admin.topup',
        component: TopupFunds,
        props: true,
        meta: {
          breadCrumb: 'Top-up',
        },
      },
      {
        path: 'payment_success',
        name: 'admin.payment_success',
        component: SubscriptionSuccess,
        props: true,
        meta: {
          breadCrumb: 'Subscription',
        },
      },
      {
        path: 'payment_fail',
        name: 'admin.payment_fail',
        component: SubscriptionFail,
        props: true,
        meta: {
          breadCrumb: 'Subscription',
        },
      },
    ],
  },
  {
    path: '/super',
    name: 'super',
    component: SuperAdminPage,
    meta: {
      breadCrumb: 'Super Admin Console',
    },
    redirect: {
      name: 'super.list',
    },
    // if the breadcrumb needs to navigate between siblings, add name && icon to each child
    children: [

      {
        path: 'list',
        name: 'super.list',
        permissions: ['super'],
        component: OrganizationManagement,
        meta: {
          breadCrumb: 'List',
          icon: 'organizations',
        },
      },
      {
        path: 'neworg',
        name: 'super.neworg',
        permissions: ['super'],
        component: AddNewOrganization,
        meta: {
          breadCrumb: 'New Organization',
          icon: 'people_add',
        },
      },
      {
        path: 'coupons',
        name: 'super.coupons',
        permissions: ['super'],
        component: CreateCoupons,

      },
      {
        path: 'editorg',
        name: 'super.editorg',
        permissions: ['admin', 'super'],
        component: EditOrganization,
      },
       {
        path: 'bills',
        name: 'super.bills',
        permissions: ['admin', 'super'],
        component: Bills,
      },
      {
        path: 'usage',
        name: 'super.usage',
        permissions: ['admin', 'super'],
        component: UsageSummary,
      },
      {
        path: 'addcredits',
        name: 'super.addcredits',
        permissions: ['super'],
        component: UserAddCredits,
      },
      {
        path: 'emulate',
        name: 'super.emulate',
        permissions: ['super'],
        component: EmulateUser,
      },
      {
        path: 'users',
        name: 'super.users',
        permissions: ['super'],
        component: UserManagement,
      },
      {
        path: 'transactions',
        name: 'super.transactions',
        component: Transactions,
        permissions: ['super'],
      },
      {
        path: 'orgdetail',
        name: 'super.orgdetail',
        permissions: ['super'],
        component: ShowDetailedOrganization,
      },
      {
        path: 'createuser',
        name: 'super.createuser',
        permissions: ['super'],
        component: CreateSecondaryUser,
      },
      {
        path: 'edituser',
        name: 'super.edituser',
        component: EditUser,
      },

    ],
  },
  {
    path: '/:projectId/experiment',
    name: 'experiment',
    component: Trainer,
    props: true,
    redirect: {
      name: 'experiment.list',
    },
    meta: {
      breadCrumb: 'Model Experiments',
    },
    children: [
      {
        path: 'list',
        name: 'experiment.list',
        component: TrainerManagement,
        props: true,
      },
      {
        path: 'training',
        name: 'experiment.training',
        component: TrainerSessionLandingPage,
        meta: {
          breadCrumb: 'Training Sessions',
        },
        redirect: {
          name: 'experiment.training.list',
        },
        children: [
          {
            path: 'list',
            name: 'experiment.training.list',
            component: TrainerSessionManagement,
            props: true,
          },
          {
            path: 'details',
            name: 'experiment.training.details',
            props: true,
            component: TrainerSessionDetailsPage,
            meta: {
              breadCrumb: 'Details',
            },
          },
          {
            path: 'charts',
            name: 'experiment.training.charts',
            props: true,
            component: TrainingChartsPage,
            meta: {
              breadCrumb: 'Charts',
            },
          },
        ],
      },
      {
        path: 'validation',
        name: 'experiment.validation',
        component: ValidatorSessionLandingPage,
        meta: {
          breadCrumb: 'Validate Sessions',
        },
        redirect: {
          name: 'experiment.validation.list',
        },
        children: [
          {
            path: 'list',
            name: 'experiment.validation.list',
            component: ValidatorManagement,
            props: true,
          },
          {
            path: 'validate',
            name: 'experiment.validation.details',
            props: true,
            component: ValidatorSessionDetailsPage,
            meta: {
              breadCrumb: 'Validate',
            },
          },
          {
            path: 'compare',
            name: 'experiment.validation.compare',
            props: true,
            component: CompareValidateSessionsPage,
            meta: {
              breadCrumb: 'Compare',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/home',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      breadCrumb: 'Home',
    },
  },
  {
    path: '/projects',
    name: 'projects',
    component: Projects,
    meta: {
      breadCrumb: 'Projects',
    },
    redirect: {
      name: 'projects.manager',
    },
    children: [
      {
        path: 'manager',
        name: 'projects.manager',
        component: ProjectManagement,
      },
      {
        path: '/projects/:projectId',
        name: 'projects.home',
        component: ProjectHome,
        meta: {
          breadCrumb: 'Home',
        },
      },
    ],
  },
  {
    path: '/apps',
    name: 'apps',
    component: Apps,
    meta: {
      breadCrumb: 'Apps',
    },
  },
  {
    path: '/:projectId/datasets',
    name: 'datasets',
    component: Datasets,
    meta: {
      breadCrumb: 'Datasets',
    },
    props: true,
    redirect: {
      name: 'datasets.manager',
    },
    children: [
      {
        path: 'manager',
        name: 'datasets.manager',
        component: DatasetManagement,
      },
      {
        path: 'gallery',
        name: 'datasets.gallery.landing',
        component: GalleryLandingPage,
        meta: {
          breadCrumb: 'Gallery',
          icon: 'gallery_thumbnail',
        },
        redirect: {
          name: 'datasets.gallery.main',
        },
        children: [
          {
            path: 'main',
            name: 'datasets.gallery.main',
            component: Gallery,
            props: true,
          },
          {
            path: 'viewer',
            name: 'datasets.gallery.viewer',
            props: true,
            component: AnnotationEditor,
            meta: {
              breadCrumb: 'Editor',
              icon: 'image',
            },
          },
        ],
      },
      {
        path: 'stats',
        name: 'datasets.statistics',
        component: DatasetStats,
        meta: {
          breadCrumb: 'Analytics',
          icon: 'insights',
        },
      },
      {
        path: 'map',
        name: 'datasets.map',
        component: Map,
        meta: {
          breadCrumb: 'Map',
          icon: 'map',
        },
      },
    ],
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About.vue'),
  },
  {
    path: '/:projectId/taskboard',
    name: 'taskboard',
    props: true,
    component: TaskBoard,
    meta: {
      breadCrumb: 'Task Board',
    },
  },
  {
    path: '/:projectId/annotator',
    name: 'annotator',
    props: true,
    component: Annotator,
    meta: {
      breadCrumb: 'Annotator',
    },
    children: [
      {
        path: '',
        name: 'annotator.editor',
        component: AnnotationEditor,
      },
    ],
  },
  {
    path: '/servers',
    name: 'servers',
    component: CloudInstancesPage,
    meta: {
      breadCrumb: 'Cloud Instances',
    },
  },
  {
    path: '/snapshots',
    name: 'snapshots',
    component: Snapshots,
    meta: {
      breadCrumb: 'Dataset Snapshots',
    },
  },
  {
    path: '/automation',
    name: 'automation',
    redirect: {
      name: 'projects.manager',
    },
    component: Automation,
    meta: {
      breadCrumb: 'Automation',
    },
  },
  {
    path: '/recycle',
    name: 'recycle',
    component: RecycleBin,
    meta: {
      breadCrumb: 'Recycle Bin',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: {
      async beforeRouteEnter(to, from, next) {
        // Invalidate the token
        const dataConnect = new DatastoreConnect();
        await dataConnect.logout()
          .then((resp) => {
            if (resp.error !== undefined) {
              throw Error(resp.error);
            }
            next({ path: "/" });
            store.commit('projects/resetState');
            store.commit('datasets/resetState');
            store.commit('statistics/resetState');
            store.commit('reviews/resetState');
            store.commit('user/logout');
          })
          .catch((error) => {
            throw error;
          });
      },
    },
  },
  {
    path: '/public',
    name: 'public',
    component: PublicLanding,
    meta: {
      breadCrumb: 'Public Projects',
    },
    props: true,
    redirect: {
      name: 'public.projects',
    },
    children: [
      {
        path: 'projects',
        name: 'public.projects',
        component: PublicProjects,
      },
      {
        path: 'projects/:projectId',
        name: 'public.project',
        component: RouterView,
        meta: {
          breadCrumb: 'Home',
        },
        redirect: {
          name: 'public.projects.home',
        },
        children: [
          {
            path: 'home',
            name: 'public.projects.home',
            component: ProjectHome,
          },
          {
            path: 'datasets',
            name: 'public.datasets',
            component: RouterView,
            meta: { breadCrumb: 'Datasets' },
            redirect: {
              name: 'public.datasets.main',
            },
            children: [
              {
                path: '',
                name: 'public.datasets.main',
                component: PublicDatasets,
              },
              // {
              //   path: 'gallery',
              //   name: 'public.datasets.gallery.main',
              //   component: Gallery,
              //   props: true,
              //   meta: {
              //     breadCrumb: 'Gallery',
              //   },
              // },
              {
                path: 'gallery',
                name: 'public.datasets.gallery',
                component: GalleryLandingPage,
                meta: {
                  breadCrumb: 'Gallery',
                  icon: 'gallery_thumbnail',
                },
                redirect: {
                  name: 'public.datasets.gallery.main',
                },
                children: [
                  {
                    path: 'main',
                    name: 'public.datasets.gallery.main',
                    component: Gallery,
                    props: true,
                  },
                  {
                    path: 'viewer',
                    name: 'public.datasets.gallery.viewer',
                    props: true,
                    component: AnnotationEditor,
                    meta: {
                      breadCrumb: 'Editor',
                      icon: 'image',
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'experiment',
            name: 'public.experiment',
            component: RouterView,
            props: true,
            redirect: {
              name: 'public.experiment.list',
            },
            meta: {
              breadCrumb: 'Model Experiments',
            },
            children: [
              {
                path: 'list',
                name: 'public.experiment.list',
                component: TrainerManagement,
                props: true,
              },
              {
                path: 'training',
                name: 'public.experiment.training',
                component: RouterView,
                meta: {
                  breadCrumb: 'Training Sessions',
                },
                redirect: {
                  name: 'public.experiment.training.list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'public.experiment.training.list',
                    component: TrainerSessionManagement,
                    props: true,
                  },
                  {
                    path: 'details',
                    name: 'public.experiment.training.details',
                    props: true,
                    component: TrainerSessionDetailsPage,
                    meta: {
                      breadCrumb: 'Details',
                    },
                  },
                  {
                    path: 'charts',
                    name: 'public.experiment.training.charts',
                    props: true,
                    component: TrainingChartsPage,
                    meta: {
                      breadCrumb: 'Charts',
                    },
                  },
                ],
              },
              {
                path: 'validation',
                name: 'public.experiment.validation',
                component: ValidatorSessionLandingPage,
                meta: {
                  breadCrumb: 'Validate Sessions',
                },
                redirect: {
                  name: 'public.experiment.validation.list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'public.experiment.validation.list',
                    component: ValidatorManagement,
                    props: true,
                  },
                  {
                    path: 'validate',
                    name: 'public.experiment.validation.details',
                    props: true,
                    component: ValidatorSessionDetailsPage,
                    meta: {
                      breadCrumb: 'Validate',
                    },
                  },
                  {
                    path: 'compare',
                    name: 'public.experiment.validation.compare',
                    props: true,
                    component: CompareValidateSessionsPage,
                    meta: {
                      breadCrumb: 'Compare',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  routes,
});

function clearTaskIntervals() {
  store.commit('tasks/resetAllTasks');
}

// navigation guard after log out
router.beforeEach(async (to, from) => {
  const publicPaths = [
    '/',
    '/login',
    '/signup',
    '/logout',
    '/home',
    '/price',
    '/reset',
    '/terms',
    '/project',
    '/contact',
    '/public',
    '/releases',
    '/forgot-password',
  ];
  const isPublicPath = publicPaths.includes(to.path) || to.path.startsWith('/public');

  try {
    const currentToken = store.state.user.token;

    if (!currentToken || isPublicPath) {
      clearTaskIntervals();
    }

    if (!currentToken && !isPublicPath) {
      clearTaskIntervals();

      // Validate user with token cookie
      const dataConnect = new DatastoreConnect();
      try {
        const authResult = await dataConnect.verifyToken()
          .then((resp) => {
            if (resp.error !== undefined) {
              throw Error(resp.error);
            }
            return resp.result;
          })
          .catch((error) => {
            throw error;
          });

        if ('changepassword' in authResult && authResult.changepassword) {
          return false;
        }
        await handleAuthentication(authResult);
      } catch (err) {
        return { path: '/login', query: { redirectPath: to.fullPath, redirectQuery: JSON.stringify(to.query) } };
      }
    }

    if (to.params.projectId) {
      const projectId = parseInt(to.params.projectId);
      if (!store.state.projects.currentProject || store.state.projects.currentProject.id !== projectId) {
        getProject(projectId);
      }
    }

    store.commit('notifications/updateNotifications');
    const user = store.state.user.user;
    if (user && user.organization_id) {
      store.dispatch('user/refreshUserList', user.organization_id);
    }
  } catch (err) {
    console.log(err);
    return false;
  }

  return true;
});

async function handleAuthentication(authResult) {
  const token = authResult.token;
  const tokenJson = parseJwt(token);
  store.commit('user/setPermissions', tokenJson.permissions);
  store.commit('user/setToken', token);

  const dataConnect = new DatastoreConnect();
  const userResp = await dataConnect.checkForUser({
    username: authResult.username,
  });

  const userObj = { ...userResp.result };
  userObj.role = userResp.result.role;
  store.commit('user/setUser', userObj);
  if (userObj.role === 'super') {
    store.commit('appVersion/setAllowDebug', 'yes');
  }
}

async function getProject(project_id) {
  const dataConnect = new DatastoreConnect();
  dataConnect.getProject({ project_id })
    .then((resp) => {
      if (resp.error) {
        throw resp.error;
      }

      if (resp.result.id) {
        store.commit('projects/setCurrentProject', resp.result);
      }
    })
    .catch((error) => {
      console.error(error);
      $toast.open({
        queue: true,
        duration: 5000,
        message: `Failed to get project`,
        type: 'error',
        position: 'top',
      });
    });
}

export default router;
